import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import API_URL from './config/apiConfig';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [authToken, setAuthToken] = useState({
        token: null,
        userId: null,
        userName: null,
        userEmail: null,
        isAdmin: null
    });
    const [loading, setLoading] = useState(true);

    const login = (token, userId, userName, userEmail, isAdmin) => {
        localStorage.setItem('token', token);
        axios.defaults.headers.common['auth-token'] =  token;
        setAuthToken({ token, userId, userName, userEmail, isAdmin });
    };

    const logout = () => {
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['auth-token'];
        setAuthToken({ token: null, userId: null, userName: null, userEmail: null, isAdmin: null });
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            axios.defaults.headers.common['auth-token'] = token;
            axios.get(`${API_URL}/auth/me`)


                .then((res) => {
                    console.log(res)
                    const { userId, userName, userEmail, isAdmin } = res.data;
                    login(token, userId, userName, userEmail, isAdmin);
                })
                .catch((err) => {
                    console.error('Erreur lors de la récupération de l\'utilisateur:', err);
                    logout();
                })
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    return (
        <AuthContext.Provider value={{ authToken, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);

